import { gql } from '@apollo/client';

export const DELETE_ENGINE_SCORING_GRID = gql`
  mutation deleteEngineScoringGrid($input: DeleteEngineScoringGridInput) {
    deleteEngineScoringGrid(input: $input) {
      commandId
    }
  }
`;
